import { useState } from 'react';
import { useSelector } from 'react-redux';

import Box from '@mui/material/Box';

import Grid from '@mui/material/Grid';

import ImageCard from '../../components/ImageCard';
import { getTranslation } from '../../utils/translate';
import ListPage from '../../layouts/ListPage';
import useCountInJunction from '../../common/hooks/useCountInJunction';
import LibraryActions from '../../components/shared/LibraryActions';
import LazyLoad from 'react-lazyload';
import useSWR from 'swr';
import { pageNumber, pageSize } from '../../utils/pagination';

const CookingMethodList = () => {
  const retailer = useSelector(state => state.retailer);

  const [language, setLanguage] = useState({
    code: 'en-US',
    name: 'English',
  });

  const [page, setPage] = useState(pageNumber);

  const { data: pageData, isLoading: pageDataLoading } = useSWR({
    url: `cooking_method?meta=*`,
    fields: `id,date_created,image,translations.*`,
    limit: pageSize,
    page,
  });

  const cookingMethodCount = useCountInJunction(
    'retailer_cooking_method',
    {
      aggregate: {
        count: '*'
      },
      filter: {
        _and: [
          { retailer_id: { _eq: retailer.id } }
        ]
      },
    },
    pageDataLoading
  );

  const summaryValues = [
    {
      label: 'Total',
      value: pageData?.meta?.total_count || '-'
    },
    {
      label: 'Collected',
      value: cookingMethodCount || '-'
    },
  ];

  return (
    <ListPage
      title='Cooking Methods'
      summaries={summaryValues}
      searchStorageKey={'cooking-methods'}
      searchOnly={['COOKING_METHODS']}
      language={language}
      setLanguage={setLanguage}
      breadcrumbsLinks={[
        {
          url: '/recipes-menu',
          content: 'Content Library'
        }
      ]}
      pageNumber={page}
      setPageNumber={setPage}
      numberOfPages={Math.ceil(pageData?.meta?.total_count / pageSize)}
      loading={pageDataLoading}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          {pageData?.data?.map((item) => (
            <Grid
              key={item.id}
              item
              xs={6}
              sm={4}
              md={4}
              lg={3}
              xl={2}
            >
              <Box
                sx={{
                  height: '100%',
                }}
              >
                <LazyLoad
                  height='100%'
                >
                  <ImageCard
                    url={`/cooking-methods/${item.id}`}
                    item={{
                      title: getTranslation(item, { key: 'languages_code', code: language.code }, 'translations')?.Method || ' ',
                      description: getTranslation(item, { key: 'languages_code', code: language.code }, 'translations')?.Description || ' ',
                      url: item.image ? `${process.env.REACT_APP_API_URL}/assets/${item.image}` : ''
                    }} 
                    footerAction={
                      <LibraryActions
                        id={item.id}
                        junctionTable='retailer_cooking_method'
                        junctionPayload={{
                          cooking_method_id: item.id,
                          retailer_id: retailer.id
                        }}
                      />
                    }
                  />
                </LazyLoad>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ListPage>
  )
}

export default CookingMethodList